import api from "./apiService";
import { clearCsrfToken } from "./csrfService";

export const loginUser = async (credentials) => {
    try {
        const response = await api.post("/login", credentials);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Logout User
export const logoutUser = async () => {
    try {
        const response = await api.post("/logout");
        
        // Clear CSRF token and cookies immediately after successful logout
        clearCsrfToken();
        
        return { message: "Logged out successfully" };
    } catch (error) {
        
        // Even if server logout fails, try to clear frontend state
        clearCsrfToken();
        
        throw error;
    }
};

// Get Current User
export const getCurrentUser = async () => {
    try {
        const response = await api.get("/profile");
        return response.data;
    } catch (error) {
        if (error.response?.status === 401) {
        }
        return null;
    }
};